module.exports = __webpack_public_path__ + "static/Innovation-Consultant-32bd473d4af5dcfe77c46d5d919661b2.png";